import React from 'react';
import { FacebookIcon, PhoneIcon } from 'lucide-react';
interface FooterProps {
  setPage: (page: string) => void;
}
export function Footer({
  setPage
}: FooterProps) {
  return <footer className="bg-steel-950 text-steel-300 pt-16 pb-8 border-t-4 border-brand-red" itemScope itemType="https://schema.org/LocalBusiness" data-id="element-21" data-mp="am5j6dy4tc2u">
      <meta itemProp="name" content="Merem Mobile Dustless Blasting Michigan, LLC" data-id="element-22" data-mp="5msvjqzfs0z7" />
      <meta itemProp="telephone" content="(517) 777-8088" data-id="element-23" data-mp="q2kji2hnvkn" />

      <div className="max-w-7xl mx-auto px-4" data-id="element-24" data-mp="3s1m13el6ztcy">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-25" data-mp="3s0u6a5zf5znq">
          {/* Col 1: Brand */}
          <div data-id="element-26" data-mp="3j28tkrgmpeuv">
            <div className="mb-6" data-id="element-27" data-mp="3j2s0ze8nkkun">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.meremblasting.com/uploaded/images/Misc%20icons%20and%20images/logo.png" alt="Merem Blasting" className="h-16 w-auto" data-id="element-28" data-mp="3j3tncev4ctro" />
            </div>
            <p className="text-sm mb-6 max-w-xs" itemProp="description" data-id="element-29" data-mp="2kcutuxpnyv2e">
              Professional mobile dustless and dry blasting services across
              Michigan. Fast turnaround, low mess, and exceptional results.
            </p>
            <a href="tel:5177778088" className="flex items-center text-white font-bold text-lg hover:text-brand-red transition-colors" data-id="element-30" data-mp="2be9fzfv5047y">
              <PhoneIcon className="w-5 h-5 mr-3 text-brand-red" data-id="element-31" data-mp="342f1w5xxfz9d" />
              (517) 777-8088
            </a>
          </div>

          {/* Col 2: Services */}
          <div data-id="element-32" data-mp="2u3693gessqol">
            <h3 className="font-heading font-bold text-xl text-white uppercase tracking-wider mb-6" data-id="element-33" data-mp="2u3pi27mh04qh">
              Services
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-34" data-mp="2z069baoyuz7s">
              <li data-id="element-35" data-mp="1in7wx3obpoj5">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-36" data-mp="1impv7riw6i3u">
                  Dustless Blasting
                </button>
              </li>
              <li data-id="element-37" data-mp="13mu4mf2pbl7u">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-38" data-mp="zje77git5gu3">
                  Dry Blasting
                </button>
              </li>
              <li data-id="element-39" data-mp="ps9uyokioa2y">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-40" data-mp="pst9rweveicr">
                  Automotive Restoration
                </button>
              </li>
              <li data-id="element-41" data-mp="bta3l95mdh33">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-42" data-mp="bss0bskji2lo">
                  Heavy Equipment Cleaning
                </button>
              </li>
              <li data-id="element-43" data-mp="265i4r48jau7b">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-44" data-mp="218hyotboprg7">
                  Graffiti Removal
                </button>
              </li>
              <li data-id="element-45" data-mp="2dq26m151ce86">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-46" data-mp="2dpj15jwknib1">
                  Concrete & Brick Restoration
                </button>
              </li>
              <li className="pt-2" data-id="element-47" data-mp="1ptemu2g08ptb">
                <button onClick={() => setPage('services-hub')} className="text-brand-red hover:text-brand-red-light transition-colors font-semibold" data-id="element-48" data-mp="1pug8t1yk6wpt">
                  View All Services →
                </button>
              </li>
            </ul>
          </div>

          {/* Col 3: Company */}
          <div data-id="element-49" data-mp="3b6hooozja5kb">
            <h3 className="font-heading font-bold text-xl text-white uppercase tracking-wider mb-6" data-id="element-50" data-mp="3b70w3brk5bk3">
              Company
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-51" data-mp="3f6i4oe2a6oth">
              <li data-id="element-52" data-mp="3dqnsmwo5dw0v">
                <button onClick={() => setPage('about')} className="hover:text-white transition-colors" data-id="element-53" data-mp="3dq4bhi6bnbnw">
                  About Us
                </button>
              </li>
              <li data-id="element-54" data-mp="3nqogmvwyp0be">
                <button onClick={() => setPage('contact')} className="hover:text-white transition-colors" data-id="element-55" data-mp="3nn0mpvnlubw5">
                  Contact & Quotes
                </button>
              </li>
              <li data-id="element-56" data-mp="3rr8c7v1vzvvf">
                <button onClick={() => setPage('resources')} className="hover:text-white transition-colors" data-id="element-57" data-mp="3rpnj89v80kzo">
                  Resources & FAQ
                </button>
              </li>
              <li data-id="element-58" data-mp="5d729i9qa17y">
                <button onClick={() => setPage('privacy')} className="hover:text-white transition-colors" data-id="element-59" data-mp="javdrzhwnw0c">
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>

          {/* Col 4: Service Areas */}
          <div data-id="element-60" data-mp="12wf49qka341x">
            <h3 className="font-heading font-bold text-xl text-white uppercase tracking-wider mb-6" data-id="element-61" data-mp="12wx8pah3gokx">
              Service Areas
            </h3>
            <ul className="space-y-3 text-sm mb-6" data-id="element-62" data-mp="owmd5u4ualtf">
              <li data-id="element-63" data-mp="tv7ig7yy7voq">
                <button onClick={() => setPage('location')} className="hover:text-white transition-colors" data-id="element-64" data-mp="tuny6kltsv7j">
                  Detroit Metro
                </button>
              </li>
              <li data-id="element-65" data-mp="jznnpow4f31k">
                <button onClick={() => setPage('location')} className="hover:text-white transition-colors" data-id="element-66" data-mp="66o8zp45xcv2">
                  Lansing / East Lansing
                </button>
              </li>
              <li data-id="element-67" data-mp="3sexkchh8rg1y">
                <button onClick={() => setPage('location')} className="hover:text-white transition-colors" data-id="element-68" data-mp="3seebrrdhe40l">
                  Grand Rapids
                </button>
              </li>
              <li data-id="element-69" data-mp="1y60s7dijbxqj">Fowlerville (HQ)</li>
              <li className="text-brand-red font-semibold" data-id="element-70" data-mp="1y4z70g7t1uv3">All of Michigan</li>
            </ul>
            <a href="https://www.facebook.com/meremblasting/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-steel-300 hover:text-white transition-colors" aria-label="Visit our Facebook page" data-id="element-71" data-mp="1u4ys6ugsnhni">
              <FacebookIcon className="w-6 h-6 mr-2" data-id="element-72" data-mp="2hu9j7k8cdxog" />
              <span className="text-sm font-medium" data-id="element-73" data-mp="2cu5esskpktel">Follow on Facebook</span>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-steel-800 flex flex-col md:flex-row justify-between items-center text-xs text-steel-500 space-y-4 md:space-y-0" data-id="element-74" data-mp="27v2bpdoagx99">
          <p data-id="element-75" data-mp="wfvnbpl66ojj">
            © {new Date().getFullYear()} Merem Mobile Dustless Blasting
            Michigan, LLC. All rights reserved.
          </p>
          <p data-id="element-76" data-mp="meb6knv9y25r">Fowlerville, Michigan — Serving All of Michigan</p>
        </div>
      </div>
    </footer>;
}